import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import { getAdvanced, parseStyleString } from '../utils';
import { PbDynamicBlock } from '../../types/pbBlocks';

export type DynamicBlockType = ContentTypeObject & PbDynamicBlock;

/**
 * Aggregates the configuration of a dynamic block element.
 * @param node
 */
export function dynamicBlockConfigAggregator(node: CustomHtmlElement): DynamicBlockType {
    const childNode = node.childNodes[0] as CustomHtmlElement;
    const style = parseStyleString(node.attributes.style);

    return {
        ...getAdvanced(node, style),
        blockId: childNode.attributes['data-uids'],
        enabled: childNode.attributes['data-banner-status'] === 'Enabled',
        uniqueID: node.attributes['data-pb-style'],
    };
}
